const TICK_RATE = 100;

export default class Time extends Phaser.GameObjects.Sprite {
    private enabled: boolean;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y, 'atlas', 'icons/cheat_time');

        this.enabled = false;

        this.setInteractive({ useHandCursor: true });
        this.on('pointerdown', this.onClick, this);

        this.disable();
    }

    onClick() {
        this.enabled = !this.enabled;

        if (this.enabled) {
            this.enable();
        } else {
            this.disable();
        }
    }

    enable() {
        this.scene.tweens.timeScale = 10;
        this.scene.time.timeScale = 10;
        this.setAlpha(1);
    }

    disable() {
        this.scene.tweens.timeScale = 1;
        this.scene.time.timeScale = 1;
        this.setAlpha(0.5);
    }
}
